export class ResponsiveNav {
  constructor() {
    const self = this;
    this._$mobileNavHamburger = jQuery(".nav-hamburger");
    this._$desktopNav = jQuery(".desktop-nav");

    // Mobile menu toggle
    this._$mobileNavHamburger.click(this._toggleMobileNav.bind(this));
    this._$desktopNav.find("a:not(.mn-has-sub)").click(this._closeMobileNav.bind(this));

    // Sub menu
    const mnHasSub = jQuery(".mn-has-sub");
    let mnThisLi;

    mnHasSub.click(function () {
      if (self._isMobile) {
        mnThisLi = jQuery(this).parent("li:first");
        if (mnThisLi.hasClass("js-opened")) {
          mnThisLi.find(".mn-sub:first").slideUp(function () {
            mnThisLi.removeClass("js-opened");
          });
        } else {
          mnThisLi.addClass("js-opened");
          mnThisLi.find(".mn-sub:first").slideDown();
        }
        return false;
      }
    });

    mnThisLi = mnHasSub.parent("li");
    mnThisLi.hover(
      function () {
        if (!self._isMobile) {
          jQuery(this).find(".mn-sub:first").stop(true, true).fadeIn("fast");
        }
      },
      function () {
        if (!self._isMobile) {
          jQuery(this).find(".mn-sub:first").stop(true, true).delay(100).fadeOut("fast");
        }
      }
    );

    if (/storefront-myer/.test(document.body.classList.value) || /myer/.test(window.location.href)) {
      this.becomeMyerStorefrontNav();
    }
  }

  becomeMyerStorefrontNav() {
    const navItemOps = [
      ["ways-to-rent", false],
      ["subscription", false],
      ["accessories", false],
      ["clearance", false],
      ["pop-up-store", true],
      ["rent-online", true],
    ];

    navItemOps.forEach(([navItemSelector, display]) => {
      const navItem = document.querySelector(`.nav-item--${navItemSelector}`);
      if (navItem) {
        if (display) {
          navItem.classList.remove("hidden");
        } else {
          navItem.remove();
        }
      }
    });
  }

  becomeMobile() {
    if (!this._isMobile === true) {
      this._isMobile = true;
      this._$desktopNav.hide();
      // Mobile menu max height
      jQuery(".desktop-nav > ul").css("max-height", jQuery(window).height() - jQuery(".main-nav").height() + "px");
      jQuery(".inner-nav li.only-logged-in, .inner-nav li.only-logged-out").removeClass("display-table");
    }
  }

  becomeDesktop() {
    if (!this._isMobile === false) {
      this._isMobile = false;
      this._$desktopNav.show();
      jQuery(".inner-nav li.only-logged-in, .inner-nav li.only-logged-out").addClass("display-table");
    }
  }

  _toggleMobileNav() {
    if (this._$desktopNav.hasClass("js-opened")) {
      this._closeMobileNav();
    } else {
      this._openMobileNav();
    }
  }

  _openMobileNav() {
    jQuery(".nav-delay-visibility").addClass("force-visible");
    if (!this._$mobileNavHamburger.hasClass("active")) {
      this._$desktopNav.slideDown("slow", "easeOutQuart").addClass("js-opened");
      this._$mobileNavHamburger.addClass("active");
    }
  }

  _closeMobileNav() {
    if (this._$mobileNavHamburger.hasClass("active")) {
      this._$desktopNav.slideUp("slow", "easeOutExpo").removeClass("js-opened");
      this._$mobileNavHamburger.removeClass("active");
    }
  }
}
